import { Icon } from '../../../../components/Icon';
import React, { FC } from 'react';
import styled from 'styled-components';

const SecondaryDiv = styled.div`
  box-sizing: border-box;
  display: flex;
  align-items: baseline;
  gap: 0.5em;
  font-size: 14px;
  color: var(--text-color-secondary) !important;
`;

type SecondaryInfoTextProps = {
  content: string;
};

export const SecondaryInfoText: FC<SecondaryInfoTextProps> = ({ content }) => {
  return (
    <SecondaryDiv>
      <Icon name="Info" width={14} style={{ top: 2, position: 'relative', flexShrink: 0 }} />
      <span>{content}</span>
    </SecondaryDiv>
  );
};
